<div class="page-container d-flex justify-content-center align-items-center">
  <div class="card p-3" style="width: 35rem;">
    <div class="logo-container">
      <img
        src="/assets/img/voxloud-wordmark_@1x.png"
        class="img-fluid"
      />
    </div>
    <div class="form-container">
      <gdp-validation-failed [error]="error" *ngIf="error"></gdp-validation-failed>
      <div class="loading" [ladda]="!error" data-spinner-size="100" *ngIf="!error"></div>
    </div>
  </div>
</div>
